<template>
  <b-row>
    <b-col md="6">
      <div v-if="cos && cos.broker_yearly_max">
        <cap-chart :userRoute="userRoute" :year="year"></cap-chart>
      </div>
      <div v-else>
        <h4 class="text-danger text-center">You do not have a Broker Yearly Max</h4>
      </div>
    </b-col>
    <b-col md="6">
      <div v-if="cos && cos.franchise_fee">
        <royalty-chart :userRoute="userRoute" :year="year"></royalty-chart>
      </div>
      <div v-else>
        <h4 class="text-danger text-center">You are not paying Franchise Fees</h4>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import CapChart from '@/views/Components/Charts/CapChart';
import RoyaltyChart from '@/views/Components/Charts/RoyaltyChart';

export default {
  components: {
    CapChart,
    RoyaltyChart
  },
  props: {
    userRoute: null,
    year: null
  },
  data() {
    return {
      cos: null
    }
  },
  methods: {
    async getCos() {
      await axios.get(this.userRoute + "/cost-of-sale?year=" + this.year)
      .then(response => {
        this.cos = response.data;
      })
      .catch(error => {
        // error
      });
    }
  },
  created() {
    this.getCos();
  }
}
</script>